import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";

// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
import Dashboard from "@/pages/Dashboard.vue"
import Orders from "@/pages/Orders.vue";
import Clients from "@/pages/Clients.vue";
import Groups from "@/pages/Groups.vue";
import Draws from "@/pages/Draws.vue";
import News from "@/pages/News.vue";

const routes = [
    {
        path: "/",
        component: DashboardLayout,
        redirect: "/dashboard",
        children: [
            {
                path: "dashboard",
                name: "Статистика",
                component: Dashboard
            },
            {
                path: "orders",
                name: "Заказы",
                component: Orders
            },
            {
                path: "clients",
                name: "Клиенты",
                component: Clients
            },
            {
                path: "groups",
                name: "Группы",
                component: Groups
            },
            {
                path: "draws",
                name: "Розыгрыши",
                component: Draws
            },
            {
                path: "news",
                name: "Рассылка",
                component: News
            },
        ]
    },
    { path: "*", component: NotFound }
];

export default routes;
